import { useTranslation } from 'react-i18next';
import { MenuList, MenuItem } from '@chakra-ui/react';
import { ISelectOption } from '../CustomSelect';

export const CustomSelectList = ({ onClickItem, options }: { onClickItem: Function; options?: ISelectOption[] }) => {
  const { t } = useTranslation();
  return (
    <MenuList maxH={200} overflow='auto' className='test'>
      {Array.isArray(options)
        ? options.map((el: ISelectOption) => {
            const { value, key, component, label } = el || {};
            return (
              <MenuItem onClick={() => onClickItem(value)} key={key}>
                {label ? t(`${label}`) : component}
              </MenuItem>
            );
          })
        : null}
    </MenuList>
  );
};
